var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"navmain"},[_c('div',{staticClass:"navtitle"},[_c('div',{staticClass:"navtitle-text"},[_c('a',{attrs:{"target":"_blank","href":"http://www.ai-tax.cn/"}},[_vm._v("进入官网")])])])])])
}]

export { render, staticRenderFns }